import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { DictionaryTypeCalendarConfigurationDto, DictionaryTypeDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Return = {
  configurationByType: Partial<Record<DictionaryTypeDto, DictionaryTypeCalendarConfigurationDto>>;
  isLoading: boolean;
};

export const useGetDictionaryTypesCalendarConfigurations = (): Return => {
  const { dictionariesApi } = useApiClient();

  const { data, isPending } = useQuery<DictionaryTypeCalendarConfigurationDto[], AxiosError>({
    queryFn: async () => (await dictionariesApi.getDictionaryTypeCalendarConfigurations()).data,
    queryKey: [QueryKeyEnum.DICTIONARIES.CALENDAR_CONFIGURATIONS],
  });

  const configurationByType: Partial<
    Record<DictionaryTypeDto, DictionaryTypeCalendarConfigurationDto>
  > = {};
  (data ?? []).forEach(configuration => {
    configurationByType[configuration.dictionaryType] = configuration;
  });

  return {
    configurationByType,
    isLoading: isPending,
  };
};
